import { createSelector } from '@ngrx/store';
import type { ApplicationState } from '../../../reducers';

export interface ConfigVersionState {
    version: string,
    apiVersions: any,
}

export const initialConfigVersionState: ConfigVersionState = {
    version: null,
    apiVersions: null,
};

export const getConfigVersionState = (state: ApplicationState) => state.configVersion;

export const getApiVersionsSelector = createSelector(getConfigVersionState, (configVersionState: ConfigVersionState) => configVersionState.apiVersions);
